import React,{useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import {useLang} from "../context/LanguageContext";
import Footer from "../components/Footer";

const HowToUsePage = () => {
  const navigate = useNavigate();
  const { t } = useLang();


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);



  return (
    <div className="relative bg-[#34495e] min-h-screen flex flex-col items-center bg-cover bg-no-repeat bg-center bg-fixed"
    style={{ backgroundImage: "url('/assets/images/laponturi-bg2.webp')" }}>

<div className="absolute inset-0 bg-[#34495e] opacity-50 z-10" />
<div className="relative z-20">

      <button
        onClick={() => navigate(-1)}
        className="absolute top-5 left-5 px-4 py-2 bg-[#2ecc71] rounded flex items-center space-x-2"
      >
        <FaArrowLeft />
        <span className="text-white" >{t('btn.back')}</span>
      </button>

      <h1 className="text-xl text-white font-bold text-center mt-16 mb-8">
          {t('txt.howToUseTitle')}
      </h1>

      <div className="max-w-[700px] mx-auto space-y-6">
        {t('howToUse').map((card, idx) => (
          <div key={idx} className="bg-white rounded shadow p-4 mx-2">
            <h2 className="text-lg font-bold mb-2">{card.title}</h2>
            <p className="text-sm text-gray-700 whitespace-pre-line">
              {card.description}
            </p>
          </div>
        ))}
      </div>
    <Footer />
    </div>
    </div>
  );
};

export default HowToUsePage;
